import React, { useState } from "react";
import HelpCenter from "@/pages/help/HelpCenter";
import HelpArticle from "@/pages/help/HelpArticle";

export default function PortalHelp({ onSubmitTicket }) {
  const [slug, setSlug] = useState(null);
  const open = (s) => { setSlug(s); window.scrollTo(0, 0); };
  if (slug) return <HelpArticle slug={slug} onBack={() => { setSlug(null); window.scrollTo(0, 0); }} onOpenArticle={open} />;
  return <HelpCenter onOpenArticle={open} onSubmitTicket={onSubmitTicket} />;
}
